import ModalWrapper from "./ModalWrapper";
import { useState } from "react";

const DeleteModal = (props) => {
  const { visible, onClose, onCancel, onDelete, title } = props;

   const [isDeleting, setIsDeleting] = useState(false);

  if (!visible) {
    return null;
  }

  const handleDelete = async () => {
    setIsDeleting(true);
    try {
      await onDelete();
    } finally {
      setIsDeleting(false);
    }
  };

  const handleCancel = () => {
    setIsDeleting(false);
    onCancel();
  };

  const handleClose = () => {
    setIsDeleting(false);
    onClose();
  };

  return (
    <ModalWrapper>
      <button
        className="close-button"
        onClick={handleClose}
        disabled={isDeleting}
        style={{
          alignSelf: "flex-end",
          opacity: isDeleting ? 0.5 : 1,
          cursor: isDeleting ? "not-allowed" : "pointer"
        }}
      >
        &times;
      </button>
      <div className="modal-body" style={{ textAlign: "center" }}>
        <h4 style={{ marginBottom: "40px" }}>{title || ""}</h4>
        <div style={{ display: "flex", justifyContent: "center", gap: "20px" }}>
          <button
            className="btn btn-outline-secondary px-5 py-2"
            onClick={handleCancel}
            disabled={isDeleting}
            style={{
              opacity: isDeleting ? 0.5 : 1,
              cursor: isDeleting ? "not-allowed" : "pointer"
            }}
          >
            Cancel
          </button>
          <button
            className="btn btn-outline-danger px-5 py-2"
            onClick={handleDelete}
            disabled={isDeleting}
            style={{
              opacity: isDeleting ? 0.8 : 1,
              cursor: isDeleting ? "not-allowed" : "pointer",
              position: "relative"
            }}
          >
            {isDeleting ? (
              <>
                <i 
                  className="fa fa-spinner fa-spin me-2" 
                  aria-hidden="true"
                ></i>
                Deleting...
              </>
            ) : (
              "Delete"
            )}
          </button>
        </div>
      </div>
    </ModalWrapper>
  );
};

export default DeleteModal;
